import { Link } from 'react-router-dom';
import { useState } from 'react';
import { categoriesColumn1, categoriesColumn2, categoriesColumn3 } from '@/mocks/categories';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.querySelector('input[name="website_alt"]') as HTMLInputElement)?.value?.trim();
    if (honeypot) {
      setSubmitted(true);
      return;
    }
    if (!email.trim()) return;
    setSubmitting(true);
    try {
      const formData = new URLSearchParams();
      formData.append('email', email.trim());
      await fetch('https://readdy.ai/api/form/d91nthj8srkha17locqg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData.toString(),
      });
      setSubmitted(true);
      setEmail('');
    } catch {
      // silently handle
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <footer className="bg-secondary-100/70 relative overflow-hidden">
      {/* 装饰 */}
      <div className="absolute top-0 left-0 w-[300px] h-[300px] rounded-full bg-primary-100/20 blur-[80px] pointer-events-none" />
      <div className="absolute bottom-0 right-0 w-[250px] h-[250px] rounded-full bg-accent-100/25 blur-[70px] pointer-events-none" />

      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20 relative z-10">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="lg:w-2/5">
            <h3 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 leading-tight">
              Join the<br />Pandabuy Blog
            </h3>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed max-w-sm">
              Stay updated with the latest pandabuyspreadsheet finds, curated categories, and trending haul discoveries. No spam, just quality updates.
            </p>
            <div className="mt-10">
              {submitted ? (
                <div className="flex items-center gap-2 text-sm text-accent-700 bg-accent-50 px-4 py-3 rounded-lg">
                  <i className="ri-check-line w-4 h-4 flex items-center justify-center"></i>
                  <span>Thanks for subscribing! We will keep you updated.</span>
                </div>
              ) : (
                <form onSubmit={handleSubmit} data-readdy-form="true">
                  <label htmlFor="footer-email" className="text-xs font-medium text-foreground-500 uppercase tracking-wider">Email for alerts</label>
                  <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" />
                  <div className="mt-2 flex flex-col sm:flex-row gap-3">
                    <input
                      id="footer-email"
                      type="email"
                      name="email"
                      required
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="your@email.com"
                      className="flex-1 bg-transparent border-b border-foreground-300 px-1 py-2 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-500 transition-colors"
                    />
                    <button
                      type="submit"
                      disabled={submitting || !email.trim()}
                      className="px-6 py-2 rounded-full border border-foreground-300 text-sm text-foreground-700 hover:border-foreground-500 hover:text-foreground-900 transition-all whitespace-nowrap cursor-pointer bg-transparent disabled:opacity-40 disabled:cursor-not-allowed"
                    >
                      {submitting ? 'Sending...' : 'Subscribe'}
                    </button>
                  </div>
                </form>
              )}
            </div>
          </div>

          <div className="lg:w-3/5 grid grid-cols-2 sm:grid-cols-3 gap-8">
            <div>
              <h4 className="text-xs font-medium text-foreground-400 uppercase tracking-wider mb-4">Categories</h4>
              <ul className="space-y-2.5">
                {categoriesColumn1.map((cat) => (
                  <li key={cat.name}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-xs font-medium text-foreground-400 uppercase tracking-wider mb-4">&nbsp;</h4>
              <ul className="space-y-2.5">
                {categoriesColumn2.map((cat) => (
                  <li key={cat.name}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-xs font-medium text-foreground-400 uppercase tracking-wider mb-4">&nbsp;</h4>
              <ul className="space-y-2.5">
                {categoriesColumn3.map((cat) => (
                  <li key={cat.name}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-4">
          <Link to="/" className="text-sm font-heading font-semibold text-foreground-900">
            pandabuy<span className="text-primary-500">.blog</span>
          </Link>
          <p className="text-xs text-foreground-400">
            We are not affiliated with Pandabuy. This is an independent curation hub. All external links open in new tabs.
          </p>
        </div>
      </div>
    </footer>
  );
}